import { useRegion } from 'common/hooks/region';
import { Routes } from 'constants/pages';
import * as React from 'react';
import { generatePath, Navigate } from 'react-router-dom';

interface Props {
  redirectTo: Routes;
}

export const RegionRedirect: React.FC<Props> = (props) => {
  const { redirectTo } = props;
  const region = useRegion();
  const to = generatePath(redirectTo, { region: region.route });
  return <Navigate to={to} replace />;
};
RegionRedirect.displayName = 'RegionRedirect';
